import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { AppState } from 'src/app/store/app.reducer';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { Lang } from 'src/app/model/lang';
import { DEFAULT_LANG, LANGUAGES } from 'src/app/conf/languages';
import { selectCurrentLang } from 'src/app/store/user/user.selector';
import { StandardPageLayout } from '../shared/stdlayoutlib/classes.stdlayoutlib';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import * as EventActions from 'src/app/store/event/event.actions';
import { selectDeleteEmailEventsNotificationsFailed, selectDeleteEmailEventsNotificationsSuccess } from 'src/app/store/event/event.selector';

@Component({
	selector: 'app-email-unsubscribe',
	templateUrl: './email-unsubscribe.component.html',
})

export class EmailUnsubscribeComponent implements OnInit, OnDestroy {
	currentLang$: Observable<Lang> = new Observable();
	currentLang: Lang = DEFAULT_LANG;
	languages = LANGUAGES;

	checkboxValue: boolean = false;

	token = '';

	deleteEmailEventsNotificationsSuccess: boolean = false;
	deleteEmailEventsNotificationsSuccess$: Observable<boolean | undefined>;
	deleteEmailEventsNotificationsSuccessSub: Subscription | undefined;
	deleteEmailEventsNotificationsFailed: boolean = false;
	deleteEmailEventsNotificationsFailed$: Observable<boolean | undefined>;
	deleteEmailEventsNotificationsFailedSub: Subscription | undefined;

	// Design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private router: Router,
		private route: ActivatedRoute,
		public app: AppComponent,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		// Store selectors
		this.deleteEmailEventsNotificationsSuccess$ = this.store.select(selectDeleteEmailEventsNotificationsSuccess);
		this.deleteEmailEventsNotificationsFailed$ = this.store.select(selectDeleteEmailEventsNotificationsFailed);
	}

	ngOnInit() {
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.currentLang$?.subscribe((lang: Lang) => {
			this.currentLang = lang;
		});
		this.token = this.route.snapshot.params['token'];
		this.subscribeAll();

		this.onResize();
	}

	ngOnDestroy(): void {
		this.deleteEmailEventsNotificationsSuccessSub?.unsubscribe();
		this.deleteEmailEventsNotificationsFailedSub?.unsubscribe();
	}

	subscribeAll() {
		this.deleteEmailEventsNotificationsSuccessSub = this.deleteEmailEventsNotificationsSuccess$?.subscribe(
			(deleteEmailEventsNotificationsSuccess) => {
				this.deleteEmailEventsNotificationsSuccess = deleteEmailEventsNotificationsSuccess;
			}
		);
		this.deleteEmailEventsNotificationsFailedSub = this.deleteEmailEventsNotificationsFailed$?.subscribe(
			(deleteEmailEventsNotificationsFailed) => {
				this.deleteEmailEventsNotificationsFailed = deleteEmailEventsNotificationsFailed;
			}
		);
	}

	setConfirmCheckbox(event: CheckboxChangeEvent) {
		this.checkboxValue = event.checked;
	}

	unsubscribeMail() {
		this.store.dispatch(EventActions.deleteEmailEventsNotifications({ token: this.token }));
		this.router.navigate(['/events/unsubscribe/' + this.token], { relativeTo: this.route });
	}

	isOverlay() {
		return this.app.menuMode === 'overlay';
	}

	isStatic() {
		return this.app.menuMode === 'static';
	}

	isHorizontal() {
		return this.app.menuMode === 'horizontal';
	}

	onTopbarSubItemClick(event: MouseEvent) {
		event.preventDefault();
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}
}